<template>
  <div class="col-12 p-0">
    <Grid
      :class="{
        no_records: result.total < 1,
      }"
      :style="{ maxHeight: '500px' }"
      :data-items="result"
      :take="dataState.take"
      :skip="dataState.skip"
      :sort="sort"
      :filter="dataState.filter"
      @datastatechange="dataStateChange"
      @sortchange="sortChangeHandler"
      :columns="finalSelectedColumns"
      :sortable="true"
      :autocomplete="true"
      :resizable="true"
      @pagechange="pageChangeHandler"
      :pageable="pageable"
    >
    </Grid>
  </div>
</template>
<script>
import "@progress/kendo-ui";
import {
  Grid,
  filterGroupByField,
  GridToolbar,
} from "@progress/kendo-vue-grid";
import { process } from "@progress/kendo-data-query";
import PricePerformanceTableGrid from "./PricePerformanceTableGrid.vue";
// import Products from "./Peel_Hunt_Component/data.json";
import { provideLocalizationService } from "@progress/kendo-vue-intl";
import { saveExcel } from "@progress/kendo-vue-excel-export";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { filterIcon } from "@progress/kendo-svg-icons";

import DownloadIcon from "../../../assets/img/icons/svg/download.svg";
import FullScreen from "../../../assets/img/icons/svg/full_screen.svg";
import cancelIcon from "../../../assets/img/icons/svg/cancelWhite.svg";
import CancelGray from "../../../assets/img/icons/svg/cancelGray.svg";
import SearchInterfaceSymbol from "../../../assets/img/icons/svg/search-interface-symbol.svg";
import kendo from "@progress/kendo-ui";
import { ListBox, ListBoxInstaller } from "@progress/kendo-listbox-vue-wrapper";

export default {
  components: {
    Grid,
    // custom: PricePerformanceTableGrid,
    // toolbar: GridToolbar,
    // dropdownlist: DropDownList,
    // "kendo-listbox": ListBox,
  },
  props: {
    tableData: {
      default() {
        return [];
      },
    },
    tableColumns: {
      default() {
        return [];
      },
    },
    sectorDropDown: {
      default() {
        return [];
      },
    },
    tableTitle: {
      default() {
        return "";
      },
    },
  },
  watch: {
    tableData: {
      deep: true,
      handler() {
        // console.log("this.products--price", this.tableData, this.products);
        this.products = [];
        this.$nextTick(() => {
          if (this.tableData && this.tableData.length) {
            this.products = this.tableData;
          } else {
            this.products = [];
          }
          this.getData();
        });
      },
    },
    tableColumns: {
      deep: true,
      handler() {
        this.columns = [];
        this.finalSelectedColumns = [];
        this.$nextTick(() => {
          if (this.tableColumns && this.tableColumns.length) {
            this.finalSelectedColumns = this.columnWidthSet(this.tableColumns);
            this.columns = this.finalSelectedColumns;
          } else {
            this.columns = [];
          }
        });
      },
    },
  },
  data: function() {
    return {
      DownloadIcon,
      FullScreen,
      cancelIcon: cancelIcon,
      cancelGray: CancelGray,
      isFullScreen: false,
      result: { data: [], total: 0 },
      sort: [],
      finalSelectedColumns: [],
      dataState: {
        take: 0,
        skip: 0,
      },
      pagerType: "numeric",
      pagerButtons: 5,
      pagerInfo: true,
      pagerSizes: true,
      pagePrevNext: true,
      skip: 0,
      take: 10,
      pageSize: 10,
      pageSizeValue: 10,
      columns: [],
      products: [],
    };
  },
  provide() {
    return {
      kendoIcons: {
        type: "svg",
        icons: {
          "more-vertical": filterIcon,
        },
      },
    };
  },
  computed: {
    pageable() {
      return {
        buttonCount: this.pagerButtons,
        info: this.pagerInfo,
        type: this.pagerType,
        pageSizes: [10, 15, 20, 100],
        previousNext: this.pagePrevNext,
        pageSizeValue: this.pageSizeValue,
      };
    },
    total() {
      return this.products ? this.products.length : 0;
    },
  },
  created: function() {
    // this.getData();
    // if (this.tableColumns && this.tableColumns.length) {
    //   this.finalSelectedColumns = this.columnWidthSet(this.tableColumns);
    // }
  },
  methods: {
    columnWidthSet: (arr) => {
      let data = [];
      arr.forEach((element) => {
        let obj = element;
        delete obj.columnMenu;
        obj.locked = false;
        // console.log("element", element);
        let width = 0;
        if (obj.title.toLowerCase() === "company") {
          width = 200;
        } else if (obj.title.length <= 3) {
          width = obj.title.length * 10 + 90;
        } else if (obj.title.length <= 5) {
          width = obj.title.length * 10 + 70;
        } else if (obj.title.length <= 10) {
          width = obj.title.length * 8 + 70;
        } else if (obj.title.length <= 15) {
          width = obj.title.length * 6 + 80;
        } else if (obj.title.length <= 20) {
          // console.log("titleeeee", obj.title);
          width = obj.title.length * 8 + 70;
        } else if (obj.title.length > 20) {
          // console.log("titleeeee", obj.title);
          width = obj.title.length * 10 + 10;
        }
        obj.width = width + "px";
        data.push(obj);
      });
      return data;
    },
    sortChangeHandler: function(event) {
      this.sort = event.sort;
      // first define all coumns name here
      let numberSortArr = [
        "Company / Index",
        "1 Month",
        "3 Month",
        "6 Month",
        "1 Year",
        "3 Year",
        "5 Year",
        "YTD",
        "Jensen's alpha (%)",
        "Beta",
        "Standard deviation (%)",
        "R-squared",
        "Treynor ratio",
        "Sharpe ratio",
        "Information ratio",
        "Sortino ratio",
      ];
      // console.log("eventtttttt", event);
      // check sort have length
      if (event.sort.length) {
        // if field name/ column name found in numberSortArr array then sort
        if (
          event.sort[0].field &&
          numberSortArr.indexOf(event.sort[0].field) > -1 &&
          event.sort[0].dir
        ) {
          // field name check, sort have direction check
          if (event.sort[0].dir && event.sort[0].field) {
            // two diffrent array have NA or not
            let with_NA_Value = [];
            let without_NA_Value = [];
            console.log("this.products", this.products);
            // push value in array
            this.products.forEach((obj, index) => {
              if (obj[event.sort[0].field] == "NA") {
                with_NA_Value.push(obj);
                console.log("[event.sort[0].field]", obj[event.sort[0].field]);
              } else {
                without_NA_Value.push(obj);
              }
            });
            // sort array without NA values
            without_NA_Value.sort((a, b) => {
              // first number initilize
              let firstNumber = a[event.sort[0].field];
              // convert string to number by multiply by 1, if the value have actual number
              firstNumber = firstNumber * 1;
              // second number initilize
              let secondNumber = b[event.sort[0].field];
              // convert string to number by multiply by 1, if the value have actual number
              secondNumber = secondNumber * 1;
              let value;
              // check the sorting direction
              if (event.sort[0].dir === "asc") {
                // check first and second number have type of number
                if (
                  typeof firstNumber === "number" &&
                  typeof secondNumber === "number"
                ) {
                  // if asc have then first and second
                  value = firstNumber - secondNumber;
                } else {
                  // if the value have string then this code execute
                  value = firstNumber.localeCompare(secondNumber, undefined, {
                    sensitivity: "base",
                  });
                }
              } else if (event.sort[0].dir === "desc") {
                if (
                  typeof firstNumber === "number" &&
                  typeof secondNumber === "number"
                ) {
                  // if desc have then second and first
                  value = secondNumber - firstNumber;
                } else {
                  // if the value have string then this code execute
                  value = secondNumber.localeCompare(firstNumber, undefined, {
                    sensitivity: "base",
                  });
                }
              }
              return value;
            });
            // join the array based on asc/desc.
            if (event.sort[0].dir === "asc") {
              this.products = [];
              setTimeout(() => {
                this.products = [...with_NA_Value, ...without_NA_Value];
                let dataState = {
                  take: this.take,
                  skip: this.skip,
                  filter: this.filter,
                };
                this.result = process(this.products, dataState);
              }, 10);
            } else if (event.sort[0].dir === "desc") {
              this.products = [];
              setTimeout(() => {
                this.products = [...without_NA_Value, ...with_NA_Value];
                let dataState = {
                  take: this.take,
                  skip: this.skip,
                  filter: this.filter,
                };
                this.result = process(this.products, dataState);
              }, 10);
            }
          }
        } else {
          this.getData();
        }
      }
    },
    pageChangeHandler: function(event) {
      //   this.loader = true;
      // The idea behind using the following setTimeout method is to
      // demonstrate how we can show a loader while fetching data.
      // In a real-life scenarios with remote data binding, the 'loader'
      // property should be updated before making a server request
      // and after the request completes.
      setTimeout(() => {
        // this.loader = false;
        this.skip = event.page.skip;
        this.take = event.event.value === 100 ? 100 : event.page.take;
        this.pageSizeValue = event.event.value;
        this.dataState.skip = event.page.skip;
        this.dataState.take = this.take;
        this.getData();
      }, 300);
    },
    getData: function() {
      let dataState = {
        take: this.take,
        skip: this.skip,
        filter: this.filter,
        sort: this.sort,
      };
      this.result = process(this.products, dataState);
    },
    createAppState: function(dataState) {
      this.take = dataState.take;
      this.skip = dataState.skip;
      this.sort = dataState.sort;
      this.filter = dataState.filter;
      this.dataState.take = this.take;
      this.dataState.skip = this.skip;
      this.dataState.sort = this.sort;
      this.dataState.filter = this.filter;
      this.getData();
    },
    dataStateChange: function(event) {
      this.createAppState(event.data);
    },
    // export to excel
    exportExcelMessage() {
      return provideLocalizationService(this).toLanguageString(
        "exportExcel",
        "Export to Excel"
      );
    },
    // export table data here in excel--------
    async exportExcel(value) {
      //   this.showToast("Preparing data for download.", "warning");
      const columnsToExportCopy = value
        ? [...this.finalSelectedColumns]
        : [...this.finalSelectedColumns];
      let columnDeepCopy = this.deepClone(columnsToExportCopy);
      let columnsToExportList = await [...this.hiddenFalse(columnDeepCopy)];
      let downloadData = value ? this.products : this.result.data;
      saveExcel({
        data: downloadData,
        group: this.group,
        fileName: "Peelhunt Report",
        columns: columnsToExportList,
      });
      //   this.showToast("File downloaded successfully.", "success");
    },
    hiddenFalse(columns) {
      let Column = columns;
      Column.forEach((col) => {
        col.hidden = false;
      });
      return Column;
    },
    // full screen table
    toggle() {
      this.isFullScreen = !this.isFullScreen;
    },
    deepClone(data) {
      return JSON.parse(JSON.stringify(data));
    },
  },
};
</script>
<style lang="scss"></style>
